import { Grid } from "@material-ui/core";
import { User } from "api";
import { useFormikContext } from "formik";
import React from "react";
import { InputFieldFormik } from "ui/componentes";

const DriverProfileForm = ({ disabled = false }) => {
    const formikContext = useFormikContext<User>();
    return (
        <Grid container spacing={1}>
            <Grid item xs={12} md={6}>
                <InputFieldFormik
                    required
                    disabled={disabled}
                    id="driverInfo.iracingId"
                    type="number"
                    name="driverInfo.iracingId"
                    label="iRacing ID"
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <Grid container spacing={1}>
                    <Grid item xs={4}>
                        <InputFieldFormik
                            disabled={disabled}
                            id="driverInfo.preferredNumbers.option1"
                            type="number"
                            name="driverInfo.preferredNumbers.option1"
                            label="Nº carro 1"
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <InputFieldFormik
                            disabled={disabled}
                            id="driverInfo.preferredNumbers.option2"
                            type="number"
                            name="driverInfo.preferredNumbers.option2"
                            label="Nº carro 2"
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <InputFieldFormik
                            disabled={disabled}
                            id="driverInfo.preferredNumbers.option3"
                            type="number"
                            name="driverInfo.preferredNumbers.option3"
                            label="Nº carro 3"
                        />
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} md={6}>
                <InputFieldFormik
                    disabled={disabled}
                    id="driverInfo.facebook"
                    name="driverInfo.facebook"
                    label="Facebook (url)"
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <InputFieldFormik
                    disabled={disabled}
                    id="driverInfo.instagram"
                    name="driverInfo.instagram"
                    label="Instagram (ex.: @irbesports)"
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <InputFieldFormik
                    disabled={disabled}
                    id="driverInfo.twitch"
                    name="driverInfo.twitch"
                    label="Twitch (url)"
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <InputFieldFormik
                    disabled={disabled}
                    id="driverInfo.website"
                    name="driverInfo.website"
                    label="Website (url)"
                />
            </Grid>
            <Grid item xs={12}>
                <InputFieldFormik
                    disabled={disabled}
                    id="driverInfo.biography"
                    name="driverInfo.biography"
                    label="Bio"
                    multiline
                    rows={10}
                    helperText={`Max.: ${formikContext.values.driverInfo?.biography?.length} / 300`}
                />
            </Grid>
        </Grid>
    );
};

export { DriverProfileForm };
